import React from 'react'
import { Heading, Text, Image } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import { Icon } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import './LayerSlider.css'

class LayerSlider extends React.Component {
  
  state = {
    currentSlide: 0,
  }

  get prevSlide() {
    let prevSlide = this.state.currentSlide - 1
    const totalSlides = this.props.children.length

    if(prevSlide < 0) prevSlide = totalSlides - 1

    return prevSlide
  }

  get nextSlide() {
    let nextSlide = this.state.currentSlide + 1
    const totalSlides = this.props.children.length

    if(nextSlide === totalSlides) nextSlide = 0

    return nextSlide
  }

  handlePrev = e => {
    this.setState(prevState => {
      const totalSlides = this.props.children.length
      let prevSlide = prevState.currentSlide - 1
      if(prevSlide < 0) prevSlide = totalSlides - 1

      return { currentSlide: prevSlide }
    })
  }

  handleNext = e => {
    this.setState(prevState => {
      const totalSlides = this.props.children.length
      let nextSlide = prevState.currentSlide + 1
      if(nextSlide === totalSlides) nextSlide = 0

      return { currentSlide: nextSlide }
    })
  }

  render(){
    return (
      <div className="Layer-slider">
        <div className="Layer-slider-container">
          {React.Children.map(this.props.children, (item, idx) => {
            if(idx === this.state.currentSlide) {
              return React.cloneElement(item, { status: 'active' })
            }

            if(idx === this.nextSlide) {
              return React.cloneElement(item, { status: 'next' })
            }if(idx === this.prevSlide) {
              return React.cloneElement(item, { status: 'prev' })
            }
          })}
        </div>
        <div className="Layer-slider-controls">
          <a onClick={this.handlePrev}><p>vorige</p><Icon name="arrow-left" /></a>    
          <a onClick={this.handleNext}><Icon name="arrow-right" /><p>volgende</p></a>
        </div>
      </div> 
    )
  }
}

const LayerSliderSlide = props => (
  <div className={`Layer-slider-slide${props.status ? ' is-'+props.status : ''}`}>
    <div className="Layer-slider-slide-image">
      <Image src={props.image} />
    </div>

    {props.status === 'active' &&
      <div className="Layer-slider-slide-content">
        <Heading h4>{props.title}</Heading>
        <Text>{props.children}</Text>
      </div>
    }
  </div>
)

export { 
  LayerSlider,
  LayerSliderSlide,
} 
